import { connect } from 'react-redux'
import TripsHistoryList from '../../components/trips/TripsHistoryList'
import { getTripsHistory as getTripsHistoryAction } from '../../state/actions/trips/index'
import { getTripsHistory, getTripsHistoryColumns } from '../../state/selectors/index'
import { IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    //TODO: use selectors
    items: getTripsHistory(state),
    columns: getTripsHistoryColumns(state),
    orgId: state.organizations.currentOrgId,
    type: ownProps.type
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getTripsHistory: (orgId: string) => {
      dispatch(getTripsHistoryAction(orgId))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripsHistoryList)



// WEBPACK FOOTER //
// ./src/containers/trips/TripsHistoryList.ts